import React from 'react';
import InstitucionalLanding from '../components/InstitucionalLanding/InstitucionalLanding';
import Timeline from '../components/Timeline/Timeline';

const Institucional = () => {
	return (
		<div>
			<InstitucionalLanding />
			<Timeline />
		</div>
	);
};

export default Institucional;
